import type { OrderServiceType } from '@constants/orderServiceType';

export type OnlineOrderStatus =
  | 'placed'
  | 'accepted'
  | 'preparing'
  | 'ready'
  | 'waiting_for_rider'
  | 'on_the_way'
  | 'delivered'
  | 'cancelled';

export interface OrderStatusEvent {
  status: OnlineOrderStatus;
  at: string;
  note?: string;
}

export interface OnlineOrderCartLine {
  id: string;
  category: string;
  itemName: string;
  variantSize: string;
  unitPrice: number;
  quantity: number;
  lineTotal: number;
  customGST?: string;
  type?: string;
  image?: string;
}

export interface OnlineOrder {
  id: string;
  orderCode: string;
  orderSeqNo?: string;
  orderSeqNum?: number;
  fiscalYear?: string;
  orderSource: 'online-menu';
  serviceType: OrderServiceType;
  restaurantId: string;
  restaurantName: string;
  phone: string;
  tableOrRoom: string;
  instructions: string;
  cart: OnlineOrderCartLine[];
  itemCount: number;
  uniqueItemCount: number;
  itemsCost: number;
  gstData: Record<string, number>;
  gstBill: number;
  serviceBill: number;
  serviceRate: number;
  gstRate: number;
  isGstBill: boolean;
  totalCost: number;
  status: OnlineOrderStatus;
  statusHistory: OrderStatusEvent[];
  /** Payment mode — cash, online, cheque, pending */
  selectedPayment?: string;
  estimatedDeliveryMinutes?: number;
  estimatedDeliveryAt?: string;
  placedAt: string;
  placedAtCoords?: { latitude: number; longitude: number } | null;
  createdAt: string;
  updatedAt: string;
}

export const POS_ORDER_STATUS_OPTIONS: Array<{ value: OnlineOrderStatus; label: string }> = [
  { value: 'placed', label: 'Incoming' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'preparing', label: 'Preparing' },
  { value: 'waiting_for_rider', label: 'Waiting For Rider' },
  { value: 'on_the_way', label: 'On the way' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const POS_ORDER_STATUS_LABELS: Record<OnlineOrderStatus, string> = {
  placed: 'Incoming',
  accepted: 'Accepted',
  preparing: 'Preparing',
  ready: 'Waiting For Rider',
  waiting_for_rider: 'Waiting For Rider',
  on_the_way: 'On the way',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
};

export const TERMINAL_ONLINE_ORDER_STATUSES: OnlineOrderStatus[] = ['delivered', 'cancelled'];

export function isActiveOnlineOrderStatus(status: OnlineOrderStatus): boolean {
  return !TERMINAL_ONLINE_ORDER_STATUSES.includes(status);
}
